import { render } from "./IdentifyDblConfirm.vue?vue&type=template&id=2dfeaa3a"
import script from "./IdentifyDblConfirm.vue?vue&type=script&lang=js"
export * from "./IdentifyDblConfirm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__